import { AppState } from '@store/state';
import { SelectedOrderModel } from './selected-order.model';
import { createSelector } from '@ngrx/store';

export const stateSelect = (state: AppState): SelectedOrderModel => state.selectedOrderData;

export const selectSelectedOrderDossierNumber = createSelector(stateSelect, ({ dossierNumber }: SelectedOrderModel) => dossierNumber);
export const selectSelectedOrderFlightDetailsIdentifier = createSelector(
  stateSelect,
  ({ flightDetailsIdentifier }: SelectedOrderModel) => flightDetailsIdentifier
);
